module.exports = __webpack_public_path__ + "static/media/kitchen.71dde031.jpg";